import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { CommonDateOnlyFormat } from 'helpers/common.helper';
import usePermissions from 'hooks/usePermissions';
import useIsMobile from 'utils/isMobileUtils';
import ShipmentItemsModal from '../modals/ShipmentItemsModal';


const ShipmentsComponent = ({ details, viewedBy = 'ADMIN' }) => {
    const [allPermissions, hasEveryPermission] = usePermissions();
    const history = useNavigate();
    const isMobile = useIsMobile();
    const [showModal, setShowModal] = useState(false);
    const [items, setItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [shipmentAddress, setShipmentAddress] = useState(null);
    
    useEffect(() => {
        if (details?.transit_company?.id) {
            const {
                shipping_address,
                shipping_city,
                shipping_zipcode,
                shipping_country,
                address,
                city,
                zipcode,
                country
            } = details.transit_company;
            const combinedAddress = [
                shipping_address || address || '',
                shipping_city || city || '',
                shipping_zipcode || zipcode || '',
                shipping_country || country || ''
            ].filter(Boolean).join(', ');
            setShipmentAddress(combinedAddress);
        } else if (details?.customer?.id) {
            const {
                shipping_address,
                shipping_city,
                shipping_zipcode,
                shipping_country,
                address,
                city,
                zipcode,
                country
            } = details.customer;
            const combinedAddress = [
                shipping_address || address || '',
                shipping_city || city || '',
                shipping_zipcode || zipcode || '',
                shipping_country || country || ''
            ].filter(Boolean).join(', ');
            setShipmentAddress(combinedAddress);

        } else {
            setShipmentAddress(null);
        }
    }, [details])

    const handleOpenNewTab = (pageModule, id, ref) => {

        let url = '';
        if (pageModule == 'products') {
            url = viewedBy === 'ADMIN' ? `/products/${id}` : `/client/products/${id}`;
        } else if (pageModule == 'contacts') {
            url = `/contacts/${id}`;
        } else if (pageModule == 'purchase_orders') {
            url = `/purchasing/view/${id}`;
        } else if (pageModule == 'sales_orders') {
            url = viewedBy === 'ADMIN' ? `/sales/sales-orders/${id}?ref=${ref}` : `/client/sales-orders/${id}?ref=${ref}`;
            // url = `/sales/sales-orders/${id}?ref=${ref}`;
        } else if (pageModule == 'invoices') {
            url = viewedBy === 'ADMIN' ? `/sales/invoices/${id}?ref=${ref}` : `/client/invoices/${id}?ref=${ref}`;
            // url = `/sales/invoices/${id}?ref=${ref}`;
        } else if (pageModule == 'quotations') {
            url = viewedBy === 'ADMIN' ? `/sales/quotations/${id}?ref=${ref}` : `/client/quotations/${id}?ref=${ref}`;
            // url = `/sales/quotations/${id}?ref=${ref}`;
        }
        if (url) {
            history(url);
        }
    };

    return (
        <>
            {!isMobile ? (
                <div style={{ padding: '0px 20px 20px 16px' }}>
                    <div className="row mb10">
                        <div className="col-12">
                            <h2 className="d-flex font600" style={{ fontSize: '18px' }}>Shipments</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 font600">Courier</div>
                        <div className="col-md-4 font600">Tracking #</div>
                        <div className="col-md-2 font600">Qty</div>
                        <div className="col-md-3 font600">Date</div>
                    </div>
                    <hr className="mt8 mb8" />
                    {
                        details?.shipments?.map((shipment, index) => (
                            <div
                                key={index}
                                className="row mb10"
                            >
                                <div className="col-md-3 d-flex align-items-center">
                                    {shipment?.shipping_company || 'N/A'}
                                </div>
                                <div className="col-md-4 d-flex align-items-center">
                                    {
                                        shipment?.tracking_number ? (
                                            <a href={`${shipment?.tracking_link}`} target="_blank" className="text-blue-500 underline">
                                                {shipment?.tracking_number}
                                            </a>
                                        ) : (
                                            'N/A'
                                        )
                                    }
                                </div>
                                <div
                                    className={`col-md-2 d-flex align-items-center ${shipment?.quantity > 0 ? 'cursor-pointer text-blue-500' : ''}`}
                                    onClick={() => {
                                        if (shipment?.quantity > 0) {
                                            setShowModal(true);
                                            setSelectedItem(shipment);
                                        }
                                    }}
                                >
                                    {shipment?.quantity ?? 0}
                                </div>
                                <div className="col-md-3 d-flex align-items-center">
                                    {moment(shipment?.date).format(CommonDateOnlyFormat) || 'N/A'}
                                </div>
                            </div>
                        ))
                    }
                    <hr className="mt8 mb8" />
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: 10 }}>
                        <h2 className="d-flex font600" style={{ fontSize: '18px' }}>
                            Shipments
                        </h2>
                    </div>
                        
                    {
                        details?.shipments?.map((shipment, index) => (
                            <div key={index}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div style={{ display: 'flex', gap: 5, alignItems: 'center', fontWeight: 500, fontSize: 14 }}>
                                        {
                                            shipment?.tracking_number ? (
                                                <a href={`${shipment?.tracking_link}`} target="_blank" className="text-blue-500 underline">
                                                    {shipment?.tracking_number}
                                                </a>
                                            ) : (
                                                'N/A'
                                            )
                                        }
                                    </div>
                                    <div>
                                        {moment(shipment?.date).format(CommonDateOnlyFormat)}
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontWeight: 500, fontSize: 14 }}>
                                    <div
                                        className={`${shipment?.quantity > 0 ? 'cursor-pointer' : ''}`}
                                        onClick={() => {
                                            if (shipment?.quantity > 0) {
                                                setShowModal(true);
                                                setSelectedItem(shipment);
                                            }
                                        }}
                                    >
                                        Shipped Qty: <span className={`${shipment?.quantity > 0 ? 'cursor-pointer text-blue-500' : ''}`}>{shipment?.quantity ?? 0}</span>
                                    </div>
                                    <div style={{ fontWeight: 500 }}>
                                        {shipment?.shipping_company || 'N/A'}
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            )}

            {
                showModal && (
                    <ShipmentItemsModal
                        openPopup={showModal}
                        details={selectedItem}
                        addressDetails={shipmentAddress}
                        handleClose={() => setShowModal(false)}
                        handleReloadData={() => {

                        }}
                    />
                )
            }
        </>
    );
};

export default ShipmentsComponent;
